import { render, staticRenderFns } from "./scroll-button.vue?vue&type=template&id=3fe83552&"
import script from "./scroll-button.vue?vue&type=script&lang=ts&"
export * from "./scroll-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe83552')) {
      api.createRecord('3fe83552', component.options)
    } else {
      api.reload('3fe83552', component.options)
    }
    module.hot.accept("./scroll-button.vue?vue&type=template&id=3fe83552&", function () {
      api.rerender('3fe83552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scroll-button.vue"
export default component.exports